import _ from "lodash";
import { Feature } from "ol";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import VectorSource from "ol/source/Vector";

export default class SingleFeatureSource<T extends Geometry> extends VectorSource<T> {
    getOrAddFeature(): Feature<T> {
        let feature = _.first(this.getFeatures())
        if(!feature) {
            feature = new Feature<T>()
            this.addFeature(feature)
        }
        return feature
    }
}